import Vue from 'vue'

import CAdjuntosList from './vue/adjuntos_list'
Vue.component('c-adjuntos-list', CAdjuntosList)

import CAdjunto from './vue/adjunto'
Vue.component('c-adjunto', CAdjunto)
